import './MoreSeriesDropdown.scss'

import classNames from 'classnames'
import Dropdown from 'lib/components/Dropdown/Dropdown'
import DropdownTrigger from 'lib/components/Dropdown/DropdownTrigger'
import AdminContext from 'lib/context/AdminContext'
import { buildQueryString, QUERY_KEYS } from 'lib/util/routing'
import Series from 'pages/Home/Series'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import MoreSeriesDropdownAdminControls from './admin/MoreSeriesDropdownAdminControls'

export interface MoreSeriesDropdownProps extends RouteComponentProps {
  openDeleteSeriesDialog: (series: Series)=> void
  openEditSeriesDialog: (series: Series)=> void
  selectedSeries?: Series
  series: Series[]
}

export default withRouter(function(props: MoreSeriesDropdownProps) {
  const { location, openDeleteSeriesDialog, openEditSeriesDialog, selectedSeries, series: seriesList } = props
  const [t] = useTranslation()
  const { showAdminControls } = useContext(AdminContext)
  const [isOpen, setIsOpen] = useState(false)
  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  const containsSelectedSeries = selectedSeries && seriesList.find(s => s.id === selectedSeries.id)
  const triggerClassName = classNames('more-series-dropdown__trigger', {
    selected: containsSelectedSeries
  })
  const title = containsSelectedSeries && !isOpen ? selectedSeries.title : undefined

  return (
    <Dropdown>
      <DropdownTrigger className={triggerClassName} title={title} onClick={open}>
        <span className="more-series-dropdown__trigger__content">{t('home.series.more')}</span>
      </DropdownTrigger>
      {isOpen && (
        <Dropdown.Menu flip={true} placement="bottom-start" onRequestClose={close}>
          {seriesList.map(series => {
            const isSelected = containsSelectedSeries && series.id === selectedSeries.id
            const className = classNames('more-series-dropdown__item', {
              'more-series-dropdown__item--selected': isSelected,
              'more-series-dropdown__item--admin': showAdminControls
            })

            return (
              <Dropdown.MenuItem
                className={className}
                isActive={isSelected}
                linkProps={{
                  to: {
                    search: buildQueryString(location, [[QUERY_KEYS.series, series.title]])
                  }
                }}
                key={series.id}>
                {series.title}
                {showAdminControls && (
                  <MoreSeriesDropdownAdminControls
                    openDeleteSeriesDialog={openDeleteSeriesDialog}
                    openEditSeriesDialog={openEditSeriesDialog}
                    series={series}
                  />
                )}
              </Dropdown.MenuItem>
            )
          })}
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
})
